import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class IsMarioGuard  {

    constructor(private http: HttpService) {

    }
    
    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {    
      const access:any = this.http.getAccess();
  
       if (!access || !access.token || !access.is_mario) {
          this.http.navigate(['/lr'])
          return false;
        }
        return true;
    }
    
  
}
